module.exports = __webpack_public_path__ + "static/media/settingsMusic.6034c54f.svg";